import { NavLink, Outlet } from "react-router-dom";

const navLinks = [
  { to: "/controller", label: "Exams", end: true },
];

export default function ControllerLayout() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Controller Panel</h1>
        <p className="mt-1 text-sm text-gray-500">Review and update exam questions</p>
      </div>

      <div className="flex items-center space-x-1 border-b border-gray-200 mb-8">
        {navLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) =>
              `px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                isActive
                  ? "border-primary-600 text-primary-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`
            }
          >
            {link.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
